import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import { Calendar, Globe, Instagram, Linkedin, Phone, Mail } from "lucide-react";

const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
};

const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const links = [
  {
    icon: Calendar,
    label: "Book a Consultation",
    url: "https://consult.modernminds.co.in",
    color: "#C9A962",
    bgColor: "bg-[#C9A962]/20",
    hoverBg: "hover:bg-[#C9A962]/30",
  },
  {
    icon: Globe,
    label: "Modern Minds Website",
    url: "https://www.modernminds.co.in/",
    color: "#7C9885",
    bgColor: "bg-[#7C9885]/20",
    hoverBg: "hover:bg-[#7C9885]/30",
  },
  {
    icon: Instagram,
    label: "Instagram",
    url: "https://www.instagram.com/isha_modernminds/",
    color: "#E4405F",
    bgColor: "bg-[#E4405F]/20",
    hoverBg: "hover:bg-[#E4405F]/30",
  },
  {
    icon: Linkedin,
    label: "LinkedIn",
    url: "https://in.linkedin.com/in/isha-rastogi",
    color: "#0A66C2",
    bgColor: "bg-[#0A66C2]/20",
    hoverBg: "hover:bg-[#0A66C2]/30",
  },
];

export const ConnectPage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center py-12 px-6">
      <Helmet>
        <title>Connect | Modern Minds</title>
        <meta name="description" content="Connect with Modern Minds - Book consultations, visit our website, follow us on Instagram and LinkedIn." />
        <link rel="canonical" href="https://www.modernminds.co.in/connect" />
      </Helmet>

      <motion.div
        variants={staggerContainer}
        initial="initial"
        animate="animate"
        className="w-full max-w-md"
      >
        {/* Logo & Header */}
        <motion.div variants={fadeInUp} className="text-center mb-8">
          <img
            src="https://customer-assets-rejwkqb3.emergentagent.net/job_modern-minds-landing/artifacts/pe71uytn_Modern%20Minds%20Logo.jpeg"
            alt="Modern Minds Logo"
            className="w-24 h-24 mx-auto rounded-full border-2 border-[#C9A962]/40 shadow-lg shadow-[#C9A962]/20 mb-4"
          />
          <h1 className="font-heading text-2xl font-bold text-white mb-1">
            Modern Minds
          </h1>
          <p className="font-body text-sm text-[#94A3B8]">
            Centre for Child Psychology
          </p>
        </motion.div>

        {/* Links */}
        <div className="space-y-3">
          {links.map((link) => (
            <motion.a
              key={link.label}
              variants={fadeInUp}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`flex items-center gap-4 w-full glass-card p-4 ${link.hoverBg} transition-all duration-300 group`}
            >
              <div
                className={`w-10 h-10 rounded-full ${link.bgColor} flex items-center justify-center flex-shrink-0`}
              >
                <link.icon size={20} style={{ color: link.color }} />
              </div>
              <span className="font-body text-base text-white group-hover:text-[#C9A962] transition-colors">
                {link.label}
              </span>
              <svg
                className="w-5 h-5 ml-auto text-[#778DA9] group-hover:text-[#C9A962] group-hover:translate-x-1 transition-all"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </motion.a>
          ))}
        </div>

        {/* Footer */}
        <motion.div variants={fadeInUp} className="text-center mt-8 space-y-3">
          <a 
            href="tel:+919569170611" 
            className="flex items-center justify-center gap-2 text-[#94A3B8] hover:text-[#C9A962] transition-colors"
          >
            <Phone size={14} />
            <span className="font-body text-sm">+91 95691 70611</span>
          </a>
          <a 
            href="mailto:isha@modernminds.co.in" 
            className="flex items-center justify-center gap-2 text-[#94A3B8] hover:text-[#C9A962] transition-colors"
          >
            <Mail size={14} />
            <span className="font-body text-sm">isha@modernminds.co.in</span>
          </a>
          <p className="font-body text-xs text-[#778DA9] pt-2">
            Gomti Nagar, Lucknow
          </p>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default ConnectPage;
